module.exports = __webpack_public_path__ + "img/meds-icon-1.21a09cc8.svg";